import { Card, makeStyles } from '@fluentui/react-components';
import { ReactNode } from 'react';

type TProps = {
  children: ReactNode;
  className?: string;
};

const useStyles = makeStyles({
  root: {
    borderRadius: '20px',
    padding: '30px',
  },
});

const Bubble = ({ children, className = '' }: TProps) => {
  const classes = useStyles();

  return (
    <div className={className}>
      <Card className={classes.root}>{children}</Card>
    </div>
  );
};

export { Bubble };
